
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class NoContentWithHint extends Vue {
  @Prop({ required: true }) title!: string;

  @Prop({ required: false, default: '' }) legend!: string;

  @Prop({ required: false, default: false }) noContent!: boolean;
}
